import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {AuthService} from '../../../Services/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-error500-page',
  templateUrl: './error500-page.component.html',
  styleUrls: ['./error500-page.component.scss'],
  standalone: false
})
export class Error500PageComponent implements OnInit, AfterViewInit {

  showDetail = false;
  errorCode = '';
  errorFromPage = '';
  errorDateTime = '';
  errorMessage = '';

  constructor(
    private authService: AuthService,
    private location: Location,
    private router: Router) {
  }

  ngOnInit(): void {
    const state = this.router.getCurrentNavigation()?.extras?.state ?? history.state;
    this.errorCode = state?.errorCode || '';
    this.errorFromPage = state?.errorFromPage || '';
    this.errorDateTime = state?.errorDateTime || '';
    this.errorMessage = state?.errorMessage || '';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this._activateMenu();
    });
  }

  goBack() {
    window.history.go(-2);
  }

  async logout() {
    await this.authService.logout(false);
  }
}
